import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class ChargeServiceExplain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '慧联充电APP服务协议';
    return (
      <div className="page_type_h5">
        <div id="chargeServiceExplain">
          <h3>提示条款</h3>
          <p>
            欢迎您与各充电用户（详见定义条款）共同签署本《慧联充电APP服务协议》（下称“本协议”）并使用慧联充电平台服务！
          </p>
          <p>
            自本协议发布之日起，慧联充电APP平台各处所称“慧联充电APP服务协议”均指本协议。
          </p>
          <p>
            各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
          </p>
          <h3>
            【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可向慧联充电APP客服咨询。
          </h3>
          <h3>
            【签约动作】当您进入充电界面、阅读并同意本协议后，即表示您已充分阅读、理解并接受本协议的全部内容，并与慧联达成一致，成为慧联平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止使用。
          </h3>
          <article>
            <h2> 一、 定义</h2>
            <section>
              <p>
                慧联充电APP平台：指包括绿色慧联（域名为www.hellogil.com/）等网站及客户端。
              </p>
              <p>
                绿色慧联：定位于绿色运力和智慧车联网平台提供商，注册资本5亿元，总部位于浙江杭州。绿色慧联以场景定制为核心，为客户提供慧联租车、慧联车服、慧联智控等新能源物流车全生命周期运营管理服务，秉承慧联人的激情、梦想、拼搏、创新精神，致力于打造绿色运力共享平台，建立绿色联盟，为推动绿色物流和智慧物流发展而努力。
              </p>
              <p>
                慧联充电APP平台服务：慧联基于互联网，以包含慧联平台网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。
              </p>
              <p>
                慧联充电APP平台规则：包括在所有慧联充电平台规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及各平台在帮派、论坛、帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。
              </p>
              <p>
                同一用户：使用同一身份认证信息的实际控制人为同一人的，均视为同一用户。
              </p>
            </section>
          </article>
          <article>
            <h2>二、 协议范围</h2>
            <section>
              <h3>2.1 签约主体</h3>
              <p>
                【平等主体】本协议由您与慧联充电平台经营者共同缔结，本协议对您与慧联充电平台经营者均具有合同效力。
              </p>
              <p>
                【主体信息】慧联充电平台经营者是指经营慧联充电平台的各法律主体。本协议项下，慧联充电平台经营者可能根据慧联充电平台的业务调整而发生变更，变更后的慧联充电平台经营者与您共同履行本协议并向您提供服务，慧联充电平台经营者的变更不会影响您本协议项下的权益。慧联充电平台经营者还有可能因为提供新的慧联充电平台服务而新增，如您使用新增的慧联充电平台服务的，视为您同意新增的慧联充电平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
              </p>
            </section>
            <section>
              <h3>2.2补充协议</h3>
              <p>
                由于互联网高速发展，您与慧联签署的本协议列明的条款并不能完整罗列并覆盖您与慧联所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，慧联充电平台法律声明及隐私权政策、慧联充电平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用慧联充电平台服务，视为您同意上述补充协议。
              </p>
            </section>
          </article>
          <article>
            <h2>三、 慧联充电平台服务及规范</h2>
            <p>
              【服务概况】您有权在慧联充电平台上享受充电、交易争议处理等服务。
            </p>
            <section>
              <p>
                3.1、
                您在使用“慧联充电APP”服务时，必须遵守中华人民共和国相关法律法规的规定，不得利用本服务进行任何违法或不正当的活动，包括但不限于下列行为：
                1）含有任何性或性暗示的； 2) 含有辱骂、恐吓、威胁内容的； 3)
                含有骚扰、垃圾广告、恶意信息、诱骗信息的； 4)
                涉及他人隐私、个人信息或资料的；
                5）煽动抗拒、破坏宪法和法律、行政法规实施的；
                6)煽动颠覆国家政权，推翻社会主义制度的；
                7)煽动分裂国家、破坏国家统一的；
                8)煽动民族仇恨、民族歧视，破坏民族团结的；
                9)捏造或者歪曲事实，散布谣言，扰乱社会秩序的；
                10)宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；
                11)公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；
                12)损害国家机关信誉和利益的； 13)其他违反宪法和法律法规的；
              </p>
            </section>
            <section>
              <p>
                3.2、在接受“慧联充电APP”提供的服务过程中，您不得从事下列行为：
                1）发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包含病毒、木马、定时炸弹等可能对“慧联充电APP”系统造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人；
                2）使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本“软件”获得的图片资料或信息；
                3）进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；
                4）修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营；
                5）
                违背“慧联充电APP”页面公布之活动规则，包括但不限于发布虚假信息、作弊或通过其他手段进行虚假交易或获取直接经济收益。
              </p>
            </section>
            <section>
              <p>
                3.3、您了解并同意：
                1)您违反上述承诺时，“慧联充电APP”有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知予您。
                2)根据相关法令的指定或者“慧联充电APP”服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，“慧联充电APP”有权采取相应措施，包括但不限于删除发布的信息内容、限制使用、暂停使用许可、终止服务、注销
                “慧联充电APP”账号、追究法律责任等措施。对恶意注册“慧联充电APP”账号或利用“慧联充电APP”账号进行违法活动，扰乱、骚扰、欺骗其他用户以及其他违反本协议的行为，“慧联充电APP”有权注销其账号。同时，“慧联充电APP”将会协助相关部门开展调查活动。
                3)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保“慧联充电APP”免于承担因此产生的损失或增加的费用。
                4)如您涉嫌违反有关法律或者本协议之规定，使“慧联充电APP”遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿“慧联充电APP”因此造成的损失及（或）发生的费用，包括合理的律师费用。
              </p>
            </section>
          </article>
          <article>
            <h2>四、责任范围</h2>
            <section>
              <p>
                4.1、“慧联充电APP”网络服务的具体内容由“慧联充电APP”根据实际情况提供。除非本服务协议另有其他明示规定，“慧联充电APP”推出的新产品、新功能、新服务，均受到本服务协议之规范。
              </p>
              <p>
                4.2、鉴于网络服务的特殊性，您知悉且同意“慧联充电APP”无需事先通知，有权随时变更、中断或终止部分或全部网络服务（包括收费网络服务）。“慧联充电APP”对网络服务是否存在中断可能性，以及网络服务的及时性、安全性、准确性均不作保证。“慧联充电APP”将定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，您知悉并同意因此类情况而造成的网络服务（包括收费网络服务）在合理时间内的中断，
                “慧联充电APP”无需为此承担任何责任，且“慧联充电APP”无需事先通知用户，有权为维修、保养、升级或其它目的而暂停任何服务。
              </p>
              <p>
                4.3、“慧联充电APP”有权于任何时间暂时或永久地修改或终止本服务（或其任何部分），而无论其通知与否，“慧联充电APP”对您或任何第三人均无需承担任何责任。
              </p>
              <p>
                4.4、您理解并接受：“慧联充电APP”信息服务平台作为信息发布、服务平台，无法控制每条信息内容的真实性或准确性。您应自行谨慎判断确定相关信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。任何信息资料，取决于用户自己并由其承担系统受损或资料丢失的所有风险和责任。
              </p>
            </section>
          </article>
          <article>
            <h2>五、隐私权政策</h2>
            <section>
              <p>
                5.1、“慧联充电APP”将在“慧联充电APP”平台公布并不时修订隐私权政策，隐私权政策构成本协议的有效组成部分。
              </p>
              <p>
                5.2、为保护您的个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。对此您表示理解和认同。
              </p>
              <p>
                5.3、你知悉并认可：“慧联充电APP”可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本网站同等的保护用户隐私的责任，则“慧联充电APP”有权将用户的注册资料等提供给该第三方。另外，在不透露单个用户隐私资料的前提下，“慧联充电APP”有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
              </p>
              <p>
                5.4、“慧联充电APP”承诺不对外公开或向第三方提供单个用户的注册资料，以下情况除外：
                1）事先获得用户的明确授权；
                2）只有透露用户个人资料，才能提供其所要求的产品和服务；
                3）根据有关的法律法规要求； 4）按照相关政府主管部门的要求；
                5）为维护“慧联充电APP”的合法权益；
                6）其余“慧联充电APP”有理由公开的情形。
              </p>
            </section>
          </article>
          <article>
            <h2>六、知识产权声明</h2>
            <section>
              <p>
                6.1、除本服务中涉及广告的知识产权由相应广告商享有外，“慧联充电APP”在本服务中提供的内容（包括但不限于网页、文字、图片、图表等）的知识产权均归“慧联充电APP”所有，但用户在使用本服务前对自己发布的内容已合法取得知识产权的除外。
              </p>
              <p>
                6.2、除另有特别声明外，“慧联充电APP”提供本服务时所依托软件的著作权、专利权及其他知识产权均归“慧联充电APP”所有。
              </p>
              <p>
                6.3、“慧联充电APP”在本服务中所涉及的图形、文字或其组成，以及其他“慧联充电APP”标志及产品、服务名称（以下统称““慧联充电APP”标识”），其著作权或商标权归“慧联充电APP”所有。未经“慧联充电APP”事先书面同意，用户不得将“慧联充电APP”标识以任何方式展示或使用或作其他处理，也不得向他人表明用户有权展示、使用、或其他有权处理“慧联充电APP”标识的行为。
              </p>
              <p>
                6.4、上述及其他任何“慧联充电APP”或相关广告商依法拥有的知识产权均受到法律保护，未经“慧联充电APP”或相关广告商书面许可，用户不得以任何形式进行使用或创造相关衍生作品。
              </p>
            </section>
          </article>
          <article>
            <h2>七、协议终止及其他</h2>
            <section>
              <p>
                7.1、您同意，“慧联充电APP”基于平台服务的安全性，有权中止向您提供部分或全部“慧联充电APP”平台服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。如果网站的安全问题是由于您的违法行为引起，“慧联充电APP”有终止向您提供部分或全部“慧联充电APP”平台服务，永久冻结（注销）您的帐户，并有权向您对损失进行索赔。
              </p>
              <p>
                7.2、您有权向“慧联充电APP”要求注销您的账户，经“慧联充电APP”审核同意的，“慧联充电APP”注销您的账户，届时，您与“慧联充电APP”基于本协议的合同关系即终止。您的账户被注销后，“慧联充电APP”没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。
              </p>
              <p>
                7.3、您同意，您与“慧联充电APP”的协议关系终止后，“慧联充电APP”仍享有下列权利：
                1)
                继续保存您未及时删除的注册信息及您使用“慧联充电APP”平台服务期间发布的所有信息至法律规定的记录保存期满。
                2）您在使用“慧联充电APP”平台服务期间存在违法行为或违反本协议和/或规则的行为的，“慧联充电APP”仍可依据本协议向您主张权利。
              </p>
            </section>
          </article>
          <article>
            <h2>八、法律适用及其他</h2>
            <section>
              <p>
                8.1、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。
              </p>
              <p>
                8.2、因本协议产生之争议，双方应通过友好协商的方式进行解决；协商不成时，任何一方均可向“慧联充电APP”公司所在地有管辖权的人民法院提起诉讼。
              </p>
            </section>
          </article>
          {/* <div class="fix-bottom-wrap">
                    <div class="rule">
                        <label class="rule-radio-label">
                            <input type="checkbox" id="ruleRadio" class="rule-radio"/>
                            我已阅读并同意
                        </label>
                        <label for="ruleRadio" class="rule-name">《慧联充电APP服务协议》</label>
                    </div>
                    <a href="javascript:;" class="yes-btn">同意</a>
                </div> */}
        </div>
      </div>
    );
  }
}

export default ChargeServiceExplain;



// WEBPACK FOOTER //
// ./src/staticPage/chargeServiceExplain/index.js